import { faCaretRight } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a Caret Right icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/caret-right?f=classic&s=solid
 */
export const CaretRightIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faCaretRight} {...props} />;
};
